import { OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '../../authentication/authentication.service';
var ShowIfHasFeatureFlagDirective = /** @class */ (function () {
    function ShowIfHasFeatureFlagDirective(templateRef, viewContainerRef, authenticationService) {
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
        this.authenticationService = authenticationService;
    }
    ShowIfHasFeatureFlagDirective.prototype.ngOnInit = function () {
        if (this.authenticationService.hasFlags(this.featureName)) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
        else {
            this.viewContainerRef.clear();
        }
    };
    return ShowIfHasFeatureFlagDirective;
}());
export { ShowIfHasFeatureFlagDirective };
